var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "email-editor",
      class: {
        "is-disabled": !_vm.editable,
        "has-appendix": !!_vm.appendixSrc,
      },
      on: {
        keyup: function ($event) {
          return _vm.$emit("keyup")
        },
        paste: function ($event) {
          return _vm.$emit("keyup")
        },
        dblclick: function ($event) {
          return _vm.$emit("dblclick", $event)
        },
      },
    },
    [
      _vm.editor && _vm.editable
        ? _c(
            "div",
            {
              key: "toolbar",
              staticClass: "email-editor-toolbar",
              on: { mousedown: _vm.keepSelection },
            },
            [
              _c("div", { staticClass: "email-editor-group" }, [
                _c(
                  "div",
                  { staticClass: "select is-small email-editor-font" },
                  [
                    _c(
                      "select",
                      {
                        attrs: { title: "Schriftart" },
                        domProps: { value: _vm.fontFamily },
                        on: {
                          change: function ($event) {
                            return _vm.setFontFamily($event.target.value)
                          },
                        },
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v(_vm._s(_vm.houseFontLabel)),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.fontFamilyOptions, function (font) {
                          return _c(
                            "option",
                            {
                              key: font.label,
                              domProps: { value: font.label },
                            },
                            [_vm._v(_vm._s(font.label))]
                          )
                        }),
                      ],
                      2
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "select is-small" }, [
                  _c(
                    "select",
                    {
                      attrs: { title: "Schriftgrad" },
                      domProps: { value: _vm.fontSize },
                      on: {
                        change: function ($event) {
                          return _vm.setFontSize($event.target.value)
                        },
                      },
                    },
                    _vm._l(_vm.fontSizes, function (size) {
                      return _c(
                        "option",
                        { key: size, domProps: { value: size } },
                        [_vm._v(_vm._s(size.replace("pt", "")))]
                      )
                    }),
                    0
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    attrs: { type: "button", title: "Schriftgrad vergrößern" },
                    on: {
                      click: function ($event) {
                        return _vm.stepFontSize(1)
                      },
                    },
                  },
                  [_vm._v("A"), _c("sup", [_vm._v("+")])]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    attrs: { type: "button", title: "Schriftgrad verkleinern" },
                    on: {
                      click: function ($event) {
                        return _vm.stepFontSize(-1)
                      },
                    },
                  },
                  [_vm._v("A"), _c("sup", [_vm._v("−")])]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "email-editor-group" }, [
                _c(
                  "button",
                  {
                    class: { "is-active": _vm.is("bold") },
                    attrs: { type: "button", title: "Fett (Strg+B)" },
                    on: {
                      click: function ($event) {
                        _vm.run((c) => c.toggleBold(), "bold")
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("format_bold"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    class: { "is-active": _vm.is("italic") },
                    attrs: { type: "button", title: "Kursiv (Strg+I)" },
                    on: {
                      click: function ($event) {
                        _vm.run((c) => c.toggleItalic(), "italic")
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("format_italic"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    class: { "is-active": _vm.is("underline") },
                    attrs: { type: "button", title: "Unterstrichen (Strg+U)" },
                    on: {
                      click: function ($event) {
                        _vm.run((c) => c.toggleUnderline(), "underline")
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("format_underlined"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    class: { "is-active": _vm.is("strike") },
                    attrs: { type: "button", title: "Durchgestrichen" },
                    on: {
                      click: function ($event) {
                        _vm.run((c) => c.toggleStrike(), "strikeThrough")
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("format_strikethrough"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "email-editor-palette-wrapper" }, [
                  _c(
                    "button",
                    {
                      attrs: {
                        type: "button",
                        title: "Texthervorhebungsfarbe",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.togglePalette("highlight")
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("border_color"),
                      ]),
                      _c("span", {
                        staticClass: "email-editor-swatch-bar",
                        style: { background: _vm.lastHighlight },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.palette === "highlight"
                    ? _c(
                        "div",
                        { staticClass: "email-editor-palette" },
                        [
                          _vm._l(_vm.highlightColors, function (color) {
                            return _c("button", {
                              key: color,
                              staticClass: "email-editor-swatch",
                              style: { background: color },
                              attrs: { type: "button", title: color },
                              on: {
                                click: function ($event) {
                                  return _vm.setHighlight(color)
                                },
                              },
                            })
                          }),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "email-editor-palette-reset",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.setHighlight(null)
                                },
                              },
                            },
                            [_vm._v("Keine Farbe")]
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "email-editor-palette-wrapper" }, [
                  _c(
                    "button",
                    {
                      attrs: { type: "button", title: "Schriftfarbe" },
                      on: {
                        click: function ($event) {
                          return _vm.togglePalette("color")
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("format_color_text"),
                      ]),
                      _c("span", {
                        staticClass: "email-editor-swatch-bar",
                        style: { background: _vm.lastColor },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.palette === "color"
                    ? _c(
                        "div",
                        { staticClass: "email-editor-palette" },
                        [
                          _vm._l(_vm.textColors, function (color) {
                            return _c("button", {
                              key: color,
                              staticClass: "email-editor-swatch",
                              style: { background: color },
                              attrs: { type: "button", title: color },
                              on: {
                                click: function ($event) {
                                  return _vm.setColor(color)
                                },
                              },
                            })
                          }),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "email-editor-palette-reset",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.setColor(null)
                                },
                              },
                            },
                            [_vm._v("Automatisch")]
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "email-editor-group" }, [
                _c(
                  "button",
                  {
                    class: { "is-active": _vm.is("bulletList") },
                    attrs: { type: "button", title: "Aufzählungszeichen" },
                    on: {
                      click: function ($event) {
                        _vm.run(
                          (c) => c.toggleBulletList(),
                          "insertUnorderedList"
                        )
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("format_list_bulleted"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    class: { "is-active": _vm.is("orderedList") },
                    attrs: { type: "button", title: "Nummerierung" },
                    on: {
                      click: function ($event) {
                        _vm.run(
                          (c) => c.toggleOrderedList(),
                          "insertOrderedList"
                        )
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("format_list_numbered"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    attrs: { type: "button", title: "Einzug verkleinern" },
                    on: {
                      click: function ($event) {
                        _vm.run((c) => c.outdent(), "outdent")
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("format_indent_decrease"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    attrs: { type: "button", title: "Einzug vergrößern" },
                    on: {
                      click: function ($event) {
                        _vm.run((c) => c.indent(), "indent")
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("format_indent_increase"),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "email-editor-group" },
                _vm._l(_vm.alignments, function (align) {
                  return _c(
                    "button",
                    {
                      key: align.value,
                      class: { "is-active": _vm.isAlign(align.value) },
                      attrs: { type: "button", title: align.title },
                      on: {
                        click: function ($event) {
                          _vm.run(
                            (c) => c.setTextAlign(align.value),
                            align.native
                          )
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v(_vm._s(align.icon)),
                      ]),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("div", { staticClass: "email-editor-group" }, [
                _c(
                  "button",
                  {
                    class: { "is-active": _vm.is("link") },
                    attrs: { type: "button", title: "Link einfügen" },
                    on: { click: _vm.setLink },
                  },
                  [_c("i", { staticClass: "material-icons" }, [_vm._v("link")])]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    attrs: { type: "button", title: "Tabelle einfügen" },
                    on: { click: _vm.insertTable },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("table_chart"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    attrs: {
                      type: "button",
                      title: "Alle Formatierungen löschen",
                    },
                    on: { click: _vm.clearFormatting },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("format_clear"),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "email-editor-group" }, [
                _c(
                  "button",
                  {
                    attrs: {
                      type: "button",
                      title: "Rückgängig (Strg+Z)",
                      disabled: !_vm.blockCell && !_vm.can((c) => c.undo()),
                    },
                    on: {
                      click: function ($event) {
                        _vm.run((c) => c.undo(), "undo")
                      },
                    },
                  },
                  [_c("i", { staticClass: "material-icons" }, [_vm._v("undo")])]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    attrs: {
                      type: "button",
                      title: "Wiederholen (Strg+Y)",
                      disabled: !_vm.blockCell && !_vm.can((c) => c.redo()),
                    },
                    on: {
                      click: function ($event) {
                        _vm.run((c) => c.redo(), "redo")
                      },
                    },
                  },
                  [_c("i", { staticClass: "material-icons" }, [_vm._v("redo")])]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "email-editor-context" }, [
                _vm.blockCell
                  ? _c(
                      "div",
                      { staticClass: "email-editor-group is-table-tools" },
                      [
                        _c(
                          "span",
                          { staticClass: "email-editor-group-label" },
                          [_vm._v("Tabelle")]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            attrs: {
                              type: "button",
                              title:
                                "Zeile oberhalb einfügen (Stil wird übernommen)",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.changeBlock("rowBefore")
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("table_rows"),
                            ]),
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("arrow_upward"),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            attrs: {
                              type: "button",
                              title:
                                "Zeile unterhalb einfügen (Stil wird übernommen)",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.changeBlock("rowAfter")
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("table_rows"),
                            ]),
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("arrow_downward"),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            attrs: { type: "button", title: "Zeile löschen" },
                            on: {
                              click: function ($event) {
                                return _vm.changeBlock("rowDelete")
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("table_rows"),
                            ]),
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("close"),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            attrs: {
                              type: "button",
                              title:
                                "Spalte links einfügen (Breite wird geteilt)",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.changeBlock("columnBefore")
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("view_column"),
                            ]),
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("arrow_back"),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            attrs: {
                              type: "button",
                              title:
                                "Spalte rechts einfügen (Breite wird geteilt)",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.changeBlock("columnAfter")
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("view_column"),
                            ]),
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("arrow_forward"),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            attrs: {
                              type: "button",
                              title:
                                "Spalte löschen (Breite geht an die Nachbarspalte)",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.changeBlock("columnDelete")
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("view_column"),
                            ]),
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("close"),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "email-editor-palette-wrapper" },
                          [
                            _c(
                              "button",
                              {
                                attrs: { type: "button", title: "Zellenfarbe" },
                                on: {
                                  click: function ($event) {
                                    return _vm.togglePalette("cell")
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("format_color_fill"),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.palette === "cell"
                              ? _c(
                                  "div",
                                  { staticClass: "email-editor-palette" },
                                  [
                                    _vm._l(_vm.cellColors, function (color) {
                                      return _c("button", {
                                        key: color,
                                        staticClass: "email-editor-swatch",
                                        style: { background: color },
                                        attrs: { type: "button", title: color },
                                        on: {
                                          click: function ($event) {
                                            return _vm.changeBlock(
                                              "cellColor",
                                              color
                                            )
                                          },
                                        },
                                      })
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "email-editor-palette-reset",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.changeBlock(
                                              "cellColor",
                                              null
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Keine Farbe")]
                                    ),
                                  ],
                                  2
                                )
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            attrs: { type: "button", title: "Tabelle löschen" },
                            on: { click: _vm.deleteBlockTable },
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v("delete"),
                            ]),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { key: "body", ref: "body", staticClass: "email-editor-body" },
        [
          _c("div", {
            key: "contentHost",
            ref: "contentHost",
            staticClass: "email-editor-content-host",
            class: {
              "has-appendix": !!_vm.appendixSrc,
              "is-disabled": !_vm.editable,
            },
            style:
              _vm.minHeight && !_vm.appendixSrc
                ? { minHeight: _vm.minHeight + "px" }
                : null,
          }),
          _vm._v(" "),
          _vm.uploading
            ? _c("div", { staticClass: "email-editor-uploading" }, [
                _vm._v("Bild wird hochgeladen …"),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.pasted && _vm.editable
            ? _c(
                "div",
                {
                  staticClass: "email-editor-paste-options",
                  style: {
                    top: _vm.pasted.top + "px",
                    left: _vm.pasted.left + "px",
                  },
                  on: {
                    mousedown: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "button",
                    {
                      attrs: { type: "button", title: "Einfügeoptionen" },
                      on: {
                        click: function ($event) {
                          _vm.pasteMenuOpen = !_vm.pasteMenuOpen
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("content_paste"),
                      ]),
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("arrow_drop_down"),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.pasteMenuOpen
                    ? _c(
                        "div",
                        { staticClass: "email-editor-paste-menu" },
                        _vm._l(_vm.pasteOptions, function (option) {
                          return _c(
                            "button",
                            {
                              key: option.mode,
                              class: {
                                "is-active": _vm.pasted.mode === option.mode,
                              },
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.applyPasteMode(option.mode)
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "material-icons" }, [
                                _vm._v(_vm._s(option.icon)),
                              ]),
                              _vm._v(
                                _vm._s(option.label) + "\n                "
                              ),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ]
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.appendixSrc
        ? _c(
            "div",
            {
              key: "appendix",
              staticClass: "email-editor-appendix",
              class: { "is-editing": _vm.signatureEditing },
            },
            [
              _vm.editable && _vm.appendixEditLabel
                ? _c("div", { staticClass: "email-editor-appendix-bar" }, [
                    _c(
                      "button",
                      {
                        staticClass: "button is-small",
                        attrs: { type: "button" },
                        on: { click: _vm.toggleSignatureEditing },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v(
                            _vm._s(_vm.signatureEditing ? "check" : "edit")
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.signatureEditing
                                ? "Fertig"
                                : _vm.appendixEditLabel
                            )
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.signatureEditing
                      ? _c(
                          "span",
                          { staticClass: "email-editor-appendix-hint" },
                          [_vm._v("Änderungen gelten nur für diese Email.")]
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("iframe", {
                ref: "appendix",
                style: { height: _vm.appendixHeight + "px" },
                attrs: {
                  sandbox:
                    "allow-same-origin allow-popups allow-popups-to-escape-sandbox",
                  srcdoc: _vm.appendixSrc,
                },
                on: { load: _vm.onAppendixLoad },
              }),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }